import { useEffect, useState } from "react";
import Sidebar from "../../components/common/Sidebar";
import Navbar from "../../components/common/Navbar";

import { getLeadsApi, assignLeadApi } from "../../services/leadsApi";
import { getStaffApi } from "../../services/authApi";

const AdminLeadAssignment = () => {

  const [leads, setLeads] = useState([]);
  const [staff, setStaff] = useState([]);
  const [selectedLeads, setSelectedLeads] = useState([]);
  const [staffId, setStaffId] = useState("");

  const user = JSON.parse(localStorage.getItem("user"));

  // FETCH LEADS
  const fetchLeads = async () => {
    const res = await getLeadsApi();
    setLeads(res.data);
  };

  // FETCH STAFF
  const fetchStaff = async () => {
    const res = await getStaffApi();
    setStaff(res.data);
  };

  useEffect(() => {
    fetchLeads();
    fetchStaff();
  }, []);

  // SELECT / UNSELECT LEAD
  const toggleLead = (id) => {
    setSelectedLeads((prev) =>
      prev.includes(id)
        ? prev.filter((l) => l !== id)
        : [...prev, id]
    );
  };

  // ASSIGN SELECTED LEADS
  const handleAssign = async () => {
    if (!staffId || selectedLeads.length === 0) {
      alert("Select leads and staff");
      return;
    }

    try {
      await Promise.all(
        selectedLeads.map((leadId) =>
          assignLeadApi(leadId, { assigned_to: staffId })
        )
      );

      alert("✅ Leads Assigned");

      setSelectedLeads([]);
      fetchLeads();

    } catch (err) {
      alert("Error assigning leads");
    }
  };

  return (
    <div className="admin-container">

      <Sidebar role={user.role} />

      <div className="admin-main">

        <Navbar />

        <div className="admin-content">

          <h2>📊 Bulk Lead Assignment</h2>

          {/* STAFF SELECT */}
          <div style={{ marginBottom: "15px" }}>
            <select
              value={staffId}
              onChange={(e) => setStaffId(e.target.value)}
            >
              <option value="">Select Staff</option>
              {staff.map((s) => (
                <option key={s.id} value={s.id}>
                  {s.name}
                </option>
              ))}
            </select>

            <button onClick={handleAssign} style={{ marginLeft: "10px" }}>
              Assign Selected
            </button>
          </div>

          {/* LEADS TABLE */}
          <table border="1" width="100%">
            <thead>
              <tr>
                <th>Select</th>
                <th>Shop</th>
                <th>Owner</th>
                <th>Phone</th>
                <th>Status</th>
              </tr>
            </thead>

            <tbody>
              {leads.map((lead) => (
                <tr key={lead.id}>
                  <td>
                    <input
                      type="checkbox"
                      checked={selectedLeads.includes(lead.id)}
                      onChange={() => toggleLead(lead.id)}
                    />
                  </td>

                  <td>{lead.shop_name}</td>
                  <td>{lead.owner_name}</td>
                  <td>{lead.phone}</td>
                  <td>{lead.status}</td>
                </tr>
              ))}
            </tbody>

          </table>

        </div>
      </div>
    </div>
  );
};

export default AdminLeadAssignment;